import React, {useState} from 'react';
import Spinner from '../../reusables/spinner';
import InputField from '../../reusables/input';
import {motion} from 'framer-motion';
import {animationValues, transitionValues} from '../../../utils/pageTransitions';
import {update_bank_details} from '../../../redux/actions/adminActions';
import {connect} from 'react-redux';

function Account({settings, updateAccount, accessToken}) {

    const [prevData,
        setPrevData] = useState(settings);

    const [formData,
        setData] = useState({
        bank_name: prevData
            ?.bank_name,
        account_number: prevData
            ?.account_number,
        account_name: prevData
            ?.account_name
    });

    const [isLoading,
        setIsLoading] = useState(false);

    const handleLoading = () => {
        setIsLoading(true);

        setInterval(() => {
            setIsLoading(false)
        }, 4000)
    }

    const handleChange = (e) => {
        setData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLoading();
        updateAccount(formData, accessToken);
    }

    return (

        <motion.div
            initial='out'
            animate='in'
            exit='out'
            variants={animationValues}
            transition={transitionValues}>

            <div className="row">
                <div className="col-lg-7">
                    <div className='sectionHeight--mid'>
                        <form className='py-3 px-2' onSubmit={handleSubmit}>
                            <div className="mt-3 mb-3">
                                <InputField
                                    type='text'
                                    label="Bank Name"
                                    name='bank_name'
                                    value={formData.bank_name}
                                    onChange={handleChange}/>
                            </div>

                            <div className="mt-3 mb-3">
                                <InputField
                                    type='text'
                                    label="Bank Account Number"
                                    name='account_number'
                                    value={formData.account_number}
                                    onChange={handleChange}/>
                            </div>

                            <div className="mt-3 mb-3">
                                <InputField
                                    type='text'
                                    label="Account Name"
                                    name='account_name'
                                    value={formData.account_name}
                                    onChange={handleChange}/>
                            </div>

                            <div className="mt-4">
                                {isLoading
                                    ? <button className="btn__filled textIsBold alignOnly">Please Wait {''}
                                            <Spinner/>
                                        </button>
                                    : <button className="btn__filled textIsBold">Save Changes</button>
}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </motion.div>
    )
}

const mapStateToProps = (state) => ({settings: state.admin.settings, accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    updateAccount: (data, token) => dispatch(update_bank_details(data, token))
})

export default connect(mapStateToProps, mapDispatchToProps)(Account)
